import React from 'react';
import { hot } from 'react-hot-loader';
import { translate } from '../../utils/locale';
import s from './Totals.scss';

const Totals = ({ setup, selection }) => {
	const { totals, discounts } = selection;

	return (
		<div className={s.totals}>
			<div className={s.totals_row}>
				<span>{ translate(setup, 'checkoutProductTotal') }</span>
				<span>{ totals.itemsTotalPrice }</span>
			</div>
			{
				totals.taxDeducted ? (
					<div className={s.totals_row}>
						<span>{ translate(setup, 'checkoutTaxReduction') }</span>
						<span>{ totals.taxDeducted }</span>
					</div>
				) : null
			}
			<div className={s.totals_row}>
				<span>{ translate(setup, 'checkoutShipping') }</span>
				<span>{ totals.shippingPriceAsNumber === 0 ? translate(setup, 'checkoutFreeShipping') : totals.shippingPrice }</span>
			</div>
			{
				discounts.anyDiscount ? (
					<div className={[s.totals_row, s.totals_row__discount].join(' ')}>
						<span>{ translate(setup, 'checkoutDiscount') }</span>
						<span>{ totals.totalDiscountPrice }</span>
					</div>
				) : null
			}
			{
				totals.taxAdded ? (
					<div className={s.totals_row}>
						<span>{ translate(setup, 'checkoutTaxAdded') }</span>
						<span>{ totals.taxAdded }</span>
					</div>
				) : null
			}
			{/*
				totals.taxPercent > 0 ? (
					<div className={s.totals_row}>
						<span>{ translate(setup, 'checkoutTaxPercent') }</span>
						<span>{ `${totals.taxPercent}%` }</span>
					</div>
				) : null
			*/}
			<div className={[s.totals_row, s.totals_row__grandTotal].join(' ')}>
				{ translate(setup, 'checkoutGrandTotal') }: { totals.grandTotalPrice }
			</div>
			{
				totals.grandTotalPriceTaxAsNumber > 0 ? (
					<div className={[s.totals_row, s.totals_row__includingTax].join(' ')}>
						{ translate(setup, 'checkoutIncludingTax') } ({totals.grandTotalPriceTax})
					</div>
				) : null
			}
		</div>
	);
};

export default hot(module)(Totals);
